import { Component, inject, input } from '@angular/core';
import { TextImage } from '../../../common/text-image/text-image.component';
import { DOMHandlerService } from '../../../../services/domhandler.service';
import { LanguageService } from '../../../../services/language.service';
import { RouterLink } from '@angular/router';
import { SharedNgxskeletonloaderModule } from '../../../../services/ngxskeletonloader.module';
import { ButtonComponent } from '../../../common/button/button.component';
import { TranslatePipe } from '@ngx-translate/core';
import { CustomDatePipe } from '../../../../pipes/date.pipe';
import { ProductService } from '../../../../services/product.service';

@Component({
    selector: 'app-blog-post',
    imports: [
        RouterLink,
        SharedNgxskeletonloaderModule,
        ButtonComponent,
        CustomDatePipe,
        TranslatePipe,
    ],
    templateUrl: './blog-post.component.html',
})
export class BlogPostComponent {
    blogPost = input.required<BlogPost>();
    productService = inject(ProductService);
    domHandler = inject(DOMHandlerService);
    languageService = inject(LanguageService);
    getNewsLink(blogPost: BlogPost): string[] {
        return [
            '/',
            this.languageService.getLanguageCode,
            'hof',
            'blog-post',
            blogPost.slug,
        ];
    }
}

export type BlogPost = {
    title: string;
    slug: string;
    date: string;
    textImages: TextImage[];
    nextBlogPost?: BlogPost;
    createdAt: string;
    updatedAt: string;
};
